import { ApaduaAPI } from './ApaduaAPI';

export class ProjectPhasesAPI extends ApaduaAPI {
    resource: string = 'api/project-phases/';

    getProjectPhases(): Promise<Array<any>> {
        return this.get('') as any;
    }
}
